import { useState, useEffect } from "react";
import { Cookie, Check, X } from "lucide-react";

const STORAGE_KEY = "smartech_cookie_consent_v1";

// Returns current consent status from localStorage.
// "accepted" | "refused" | null (not yet decided)
export const getCookieConsent = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      const choice = getCookieConsent();
      if (!choice) setVisible(true);
    }, 600);
    return () => clearTimeout(t);
  }, []);

  const setChoice = (v) => {
    try { localStorage.setItem(STORAGE_KEY, v); } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="cookie-consent"
      role="dialog"
      aria-label="Gestion des cookies"
      data-testid="cookie-consent-banner"
    >
      <div className="cookie-consent-inner">
        <div className="cookie-consent-icon">
          <Cookie size={22} />
        </div>
        <div className="cookie-consent-text">
          <div className="cookie-consent-title">
            ⚡ Expérience optimisée requise
          </div>
          <p className="cookie-consent-body">
            Pour activer toutes les fonctionnalités (suivi des services, transactions rapides,
            accès sécurisé), l'activation des cookies est recommandée.
            Sans cookies, certaines fonctionnalités peuvent être limitées.
            <br />
            👉 <b>Autorisez-vous les cookies pour une utilisation complète ?</b>
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button
            className="cookie-btn cookie-btn-accept"
            onClick={() => setChoice("accepted")}
            data-testid="cookie-accept"
          >
            <Check size={14} /> Oui, j'accepte
          </button>
          <button
            className="cookie-btn cookie-btn-refuse"
            onClick={() => setChoice("refused")}
            data-testid="cookie-refuse"
          >
            <X size={14} /> Continuer limité
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
